import { CSSResultGroup, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-tab.css.lit';
import { classMap } from 'lit/directives/class-map.js';
import OutlineTab from 'src/components/base/outline-tabs/outline-tab/outline-tab';

let id = 0;

/**
 * The IdbTab component
 * @element idb-tab
 */
@customElement('idb-tab')
export class IdbTab extends OutlineTab {
  static styles: CSSResultGroup = [OutlineTab.styles, componentStyles];

  private idbComponentId = `tab-${++id}`;

  @property({ type: String, attribute: 'tab-style' })
  tabStyle: 'default' | 'stats';

  render() {
    this.id = this.id || this.idbComponentId;

    return html`
      <div
        part="base"
        class=${classMap({
          'tab': true,
          'tab--active': this.active,
          'tab--disabled': this.disabled,
          [`style--${this.tabStyle}`]: this.tabStyle,
        })}
        role="tab"
        aria-disabled=${this.disabled ? 'true' : 'false'}
        aria-selected=${this.active ? 'true' : 'false'}
        tabindex=${this.disabled || !this.active ? '-1' : '0'}
      >
        <slot> </slot>
      </div>
    `;
  }
}
